import React from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";

const routes = all_routes;

const LanguageSettings = () => {
  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
          <div className="my-auto mb-2">
            <h2 className="mb-1">Language Settings</h2>
            <nav>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <Link to={routes.adminDashboard}>
                    <i className="ti ti-smart-home" />
                  </Link>
                </li>
                <li className="breadcrumb-item">Administration</li>
                <li className="breadcrumb-item active" aria-current="page">
                  Language Settings
                </li>
              </ol>
            </nav>
          </div>
          <div className="head-icons ms-2">
            <CollapseHeader />
          </div>
        </div>

        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              <div className="card-body">
                <div className="border-bottom mb-3 pb-3">
                  <h4>Language Configuration</h4>
                </div>
                <form>
                  <div className="row mb-4">
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label">
                          Default Language
                        </label>
                        <select className="form-select">
                          <option>English</option>
                          <option>French</option>
                          <option>Spanish</option>
                          <option>German</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label">
                          Auto Detect Language
                        </label>
                        <div className="form-check form-switch">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            role="switch"
                            id="autoDetectLanguage"
                          />
                          <label
                            className="form-check-label"
                            htmlFor="autoDetectLanguage"
                          >
                            Enable automatic language detection
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="border-bottom mb-3">
                    <h5>Available Languages</h5>
                    <div className="row">
                      {[
                        "English",
                        "French",
                        "Spanish",
                        "German",
                        "Italian",
                        "Portuguese",
                      ].map((lang, index) => (
                        <div key={index} className="col-md-4 mb-3">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              id={`lang${index}`}
                              defaultChecked={index < 3}
                            />
                            <label
                              className="form-check-label"
                              htmlFor={`lang${index}`}
                            >
                              {lang}
                            </label>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className="d-flex align-items-center justify-content-end">
                    <button
                      type="button"
                      className="btn btn-outline-light border me-3"
                    >
                      Cancel
                    </button>
                    <button type="submit" className="btn btn-primary">
                      Save Changes
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
        <p className="mb-0">DMRC Admin Panel, All Rights Reserved.</p>
      </div>
    </div>
  );
};

export default LanguageSettings;